import type {
  AccountingPeriodListQuery,
  AccountingPeriodRuleView,
  AccountingPeriodView,
  CreateAccountingPeriodInput,
  Page,
  UnlockAccountingPeriodInput,
} from '@chukua/common';
import { api } from '../../shared/shared.api';
import { toListParams } from '../../shared/policies/list-params';

export function listAccountingPeriods(query: AccountingPeriodListQuery): Promise<Page<AccountingPeriodView>> {
  return api<Page<AccountingPeriodView>>(`/accounting-periods?${toListParams(query)}`);
}

export function createAccountingPeriod(input: CreateAccountingPeriodInput): Promise<AccountingPeriodView> {
  return api<AccountingPeriodView>('/accounting-periods', { method: 'POST', body: JSON.stringify(input) });
}

export function closeAccountingPeriod(id: string): Promise<AccountingPeriodView> {
  return api<AccountingPeriodView>(`/accounting-periods/${id}/close`, { method: 'POST' });
}

export function lockAccountingPeriod(id: string): Promise<AccountingPeriodView> {
  return api<AccountingPeriodView>(`/accounting-periods/${id}/lock`, { method: 'POST' });
}

export function unlockAccountingPeriod(id: string, input: UnlockAccountingPeriodInput): Promise<AccountingPeriodView> {
  return api<AccountingPeriodView>(`/accounting-periods/${id}/unlock`, { method: 'POST', body: JSON.stringify(input) });
}

export function getAccountingPeriodRule(): Promise<AccountingPeriodRuleView> {
  return api<AccountingPeriodRuleView>('/accounting-period-rule');
}

export function setAccountingPeriodRule(startDay: number): Promise<AccountingPeriodRuleView> {
  return api<AccountingPeriodRuleView>('/accounting-period-rule', { method: 'PUT', body: JSON.stringify({ startDay }) });
}
